import { render, staticRenderFns } from "./TheLayoutToolbar.vue?vue&type=template&id=45be2274&scoped=true"
import script from "./TheLayoutToolbar.vue?vue&type=script&lang=js"
export * from "./TheLayoutToolbar.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutToolbar.vue?vue&type=style&index=0&id=45be2274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be2274",
  null
  
)

export default component.exports